"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DurationUnitLabels = exports.DurationUnit = exports.DurationUnits = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.DurationUnits = ['HOURS', 'DAYS', 'WEEKS', 'MONTHS', 'YEARS'];
exports.DurationUnit = typebox_1.Type.Union(exports.DurationUnits.map((unit) => typebox_1.Type.Literal(unit)));
exports.DurationUnitLabels = {
    HOURS: {
        singular: 'Hour',
        plural: 'Hours',
        adverb: 'Hourly',
    },
    DAYS: {
        singular: 'Day',
        plural: 'Days',
        adverb: 'Daily',
    },
    WEEKS: {
        singular: 'Week',
        plural: 'Weeks',
        adverb: 'Weekly',
    },
    MONTHS: {
        singular: 'Month',
        plural: 'Months',
        adverb: 'Monthly',
    },
    YEARS: {
        singular: 'Year',
        plural: 'Years',
        adverb: 'Yearly',
    },
};
//# sourceMappingURL=duration-unit.js.map